/* eslint-disable */
import { useState, useMemo, useCallback, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Button, Message } from 'semantic-ui-react';
import AppContext from '../../../context/HeaderContext';
import Duration from '../../../components/Duration';
import CenterCell from '../../../components/table/CenterCell';
import RightCell from '../../../components/table/RightCell';
import ServerPaginatedTable from '../../../components/table/ServerPaginatedTable';
import { getAPI } from '../../../libs/fetchAPI';
import PassFailResult from '../../../components/PassFailResult';
import IntroMessage from '../../../components/IntroMessage';
import JiraLink from '../../../components/JiraLink';

function Runs({ handleRunClick }) {
	const { current_project_id }       = useContext(AppContext);
	const [ loading, setLoading ]      = useState(true);
	const [ test_runs, setTestRuns ]   = useState([]);
	const [ page_count, setPageCount ] = useState();
	const fetch_id_ref                 = useRef(0);

	const fetchTableData = useCallback(({ pageIndex, pageSize, filters, sortBy }) => {
		const fetch_id = ++fetch_id_ref.current;

		if(fetch_id !== fetch_id_ref.current) {
			return;
		}

		let sort_key       = `run_date`;
		let sort_direction = `DESC`;

		if(sortBy.length) {
			sort_key       = sortBy[0].id;
			sort_direction = sortBy[0].desc ? `DESC` : `ASC`;
		}

		const params =  {
			project_id : current_project_id,
			limit      : pageSize,
			offset     : pageSize * pageIndex,
			sort_key,
			sort_direction,
			filters : JSON.stringify(filters),
		};

		setLoading(true);
		getAPI(`/runs?${new URLSearchParams(params).toString()}`)
			.then(({ data, pages }) => {
				setTestRuns(data);
				setPageCount(pages);

				setLoading(false);
			});
	}, [current_project_id]);

	/* eslint-disable */
	const columns = useMemo(() => [
		{
			Header   : `Date`,
			accessor : `run_date`,
			Cell     : ({ cell }) => <span>{new Date(`${cell.value} UTC`).toLocaleString()}</span>
		},
		{
			Header   : `Name`,
			accessor : `title`,
			Cell     : ({ cell }) => <JiraLink issue_key={cell.value} />
		},
		{
			Header   : `Version`,
			accessor : `version`,
			collapse : true,
			Cell     : ({ cell }) => <span>{cell.value || `N/A`}</span>
		},
		{
			Header   : `Capabilities`,
			accessor : `capabilities`,
		},
		{
			Header   : `Suites Ran`,
			accessor : `suites_ran`,
		},
		{
			Header   : `Duration`,
			accessor : `duration`,
			Cell     : ({ cell }) => <RightCell><Duration duration={cell.value} /></RightCell>
		},
		{
			Header   : `Retries`,
			accessor : `total_retries`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Pass / Fail`,
			accessor : `total_passed`,
			Cell     : ({ cell }) => {
				return <RightCell>{cell.value} / {cell.row.values.total_failed}</RightCell>
			}
		},
		{
			Header   : `Result`,
			accessor : `passed`,
			collapse : true,
			Cell     : ({ cell }) => <PassFailResult passed={cell.value} skipped={cell.row.values.skipped} />
		},
		{
			Header   : `Skipped Hidden`,
			accessor : `skipped`,
		},
		{
			Header   : `Failed Hidden`,
			accessor : `total_failed`,
		},
		{
			Header   : ``,
			accessor : `id`,
			collapse : true,
			Cell     : ({ cell }) => <CenterCell><Link to={`runs/${cell.value}`} onClick={() => handleRunClick(cell.value)}><Button primary>View</Button></Link></CenterCell>
		}
	], []);
	/* eslint-enable */

	return (
		<>
			<IntroMessage
				id={1}
				message='This Test Runs -> Runs page lists each individual test run. By clicking the "View" button on a test run you can view all the suites and tests that were executed for a particular run. A test run could come from many different places like running tests from a local computer, CI/CD, a trigger in Github/Jira/Gitlab, etc. when a pull request is made.'
			/>

			<ServerPaginatedTable
				columns={columns}
				data={test_runs}
				fetchTableData={fetchTableData}
				loading={loading}
				pageCount={page_count}
				current_project_id={current_project_id}
				default_page_size="15"
				hidden_columns={[`skipped`, `total_failed`]}
			/>
		</>
	);
}

export default Runs;
